import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Badge, Input, Label, Button, Form, Alert, FormGroup, CardImg } from "reactstrap";
import { post, put, get } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate, Link } from "react-router-dom";
import { ADD_DRIVER, ADD_USER, ASSIGN_ROLE, VEHICLES_SEARCH, DRIVER_TYPE_SEARCH, VEHICLE_CHECK_ALLOCATED, UPDATE_DRIVER_DRIVER_TYPE
    , ASSIGN_DELIVERY_TYPE_ACTIVATE, PARTNERS_BRANCH_SEARCH, UPDATE_DRIVER_PARTNERBRANCHES, UPLOAD_FILE } from "helpers/api_endpoints";
import Select from "react-select";
import ChooseModal from "../../components/Common/ChooseModal";
import PhoneInput from 'react-country-phone-input'
import 'react-country-phone-input/lib/style.css'
import { all } from "axios";


//meta title
document.title = "Add Driver";

const AddDriver = () => {

    const [status, setStatus] = useState(1);
    const [username, setUsername] = useState('');
    const [deliveryTypes, setDeliveryTypes] = useState([]);
    const [allowExpressChange, setAllowExpressChange] = useState(true);
    const [partnerBranches, setPartnerBranches] = useState([]);
    const [selectedPartnerBranches, setSelectedPartnerBranches] = useState([]);
    const [expressDeliveryTypeActivate, setExpressDeliveryTypeActivate] = useState([]);
    const [currentExpressOrderId, setCurrentExpressOrderId] = useState('');
    const [vehicleId, setVehicleId] = useState({});
    const [vehicles, setVehicles] = useState([]);
    const [driverTypes, setDriverTypes] = useState([]);
    const [selectedDriverTypes, setSelectedDriverTypes] = useState([]);
    const [vehicleTempId, setVehicleTempId] = useState(0);
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [walletBalance, setWalletBalance] = useState('');
    const [chooseModal, setChooseModal] = useState(false);
    const [password, setPassword] = useState('');
    const [driverType, setDriverType] = useState([]);
    const [userId, setUserId] = useState('');
    const [emirateId, setEmirateid] = useState('');
    const [driverName, setDriverName] = useState('');
    const [photo, setPhoto] = useState(null);
    const [licenseNo, setLicenseNo] = useState('');
    const [licenseExpiry, setLicenseExpiry] = useState('');
    const [cargoEmployee, setCargoEmployee] = useState(0);
    const [offDays, setOffDays] = useState({range:[{from:'', to:''}], recurring:[]});
    const [errorMsg, seterrorMsg] = useState('');
    const navigate = useNavigate();
	const dayOptions = [
		{ value: 0, label: "Sunday" },
		{ value: 1, label: "Monday" },
		{ value: 2, label: "Tuesday" },
		{ value: 3, label: "Wednesday" },
		{ value: 4, label: "Thursday" },
		{ value: 5, label: "Friday" },
		{ value: 6, label: "Saturday" },
	];

    const handleSubmit = () => {
        saveUserData();
    }

    useEffect(() => {
        getVehicles();
        getDriverTypes();
        getPartnerBranches();
    }, []);

    const handleToggleCheckBox = (inputFunction, value='') => {
        switch (inputFunction) {
            case 'setStatus':
                if (status == 1) {
                    setStatus(1);
                }
                else {
                    setStatus(2);
                }
                break;
            case 'setCargoEmployee':
                if (cargoEmployee == 1) {
                    setCargoEmployee(0);
                }
                else {
                    setCargoEmployee(1);
                }
                break;
            case 'driverType':
                const newDriverType = [...selectedDriverTypes];
                console.log('newDriverType', newDriverType)
                const i = newDriverType.indexOf(value);
                if(i < 0)
                    newDriverType.push(value);
                else
                    newDriverType.splice(i, 1);
                console.log('DriverType', newDriverType)
                setSelectedDriverTypes(newDriverType);
                break;
            case 'setExpressDeliveryTypeActivate':
                if (expressDeliveryTypeActivate == 1) {
                    setExpressDeliveryTypeActivate(2);
                }
                else {
                    setExpressDeliveryTypeActivate(1);
                }
                break;
            default:
                break;
        }
    }

   const getVehicles = () => {
         post(`${VEHICLES_SEARCH}`)
             .then(response =>{
                 setVehicles([{value:'0',label:'None'}].concat(response.data.map(el=>{
                    return {value:el.id,label:el.id + ' - ' + el.name + ' - '+ el.plateNo}
                 })));
             })
     };
 
     const getDriverTypes = () => {
         post(`${DRIVER_TYPE_SEARCH}`)
             .then(response =>{
                 setDriverTypes(response.data);
             })
     };
    
     const getPartnerBranches = () => {
         post(`${PARTNERS_BRANCH_SEARCH}`)
             .then(response =>{
                 setPartnerBranches(response.data.map(el => {
                    return {label:el.name, value:el.id, data:el}
                 }));
             })
     };
    
    const checkDriverType = (id) => {
        const found = selectedDriverTypes.indexOf(id) > -1;
        return found;
    };

    const updateDriverType = (driverId) => {
        selectedDriverTypes.forEach(el => {
            put(UPDATE_DRIVER_DRIVER_TYPE, { driverId:driverId, driverTypeId:el, op:2 })
                .then(response => {
                    if (response.code == 201) {
                    }
                })
                .catch(error => {
                    console.log(error);
                })

        })
    };

    const handlePartnerBranches = (branchs) => {
        setSelectedPartnerBranches(branchs?.map(el => {
            return el.value;
        }));
    }

    const saveUserData = () => {
        post(ADD_USER, { name: username, email, password, mobile, emirateId, status })
            .then(response => {
                if (response.code == 201) {
                    const userData = response.data;
                    if (userData.id) {
                        assignDriverRole(userData);
                        saveDriverData(userData);
                    }
                    else {
                        seterrorMsg('Driver Creation Failed');
                    }
                }
            })
            .catch(error => {
                console.log(error)
                seterrorMsg(error?.response?.data?.message);
            })
    }

    const saveDriverData = (userData) => {
        post(ADD_DRIVER, { userId: userData.id, name: driverName, walletBalance, licenseNo, licenseExpiry, cargoEmployee, offDays, allowExpressChange, photo })
            .then(response => {
                updateDriverType(response.data.id);
                assignExpressDeliveryType(response.data.id);
                assignPartnerBranches(response.data.id);
                if (response.code == 201) {
                    navigate('/drivers', { state: { successMsg: 'Driver Added SuccessFully' } });
                }
            })
            .catch(error => {
                console.log(error)
                seterrorMsg(error?.response?.data?.message);
            })
    }

    const updateVehicleData = (id) => {
        post(VEHICLE_ASSIGN_DRIVER, { DriverId:id, VehicleId:vehicleId.value })
            .then(response => {
                if (response.code == 200) {
                    // navigate('/drivers', { state: { successMsg: 'Driver Updated SuccessFully' } });
                }
            })
            .catch(error => {
                seterrorMsg('Driver Creation vehicle Failed');
            })
    }

    const handleReallocate = () => {
        setVehicleId(vehicleTempId);
        setChooseModal(false);
        
    };


    const checkAllocated = (value) => {
        return post(`${VEHICLE_CHECK_ALLOCATED}`,{VehicleId:value});
    }

    const handleVehicleId = (value) => {
        checkAllocated(value).then(result => {
            if(result.data=='false')
            {
                setVehicleId(vehicles.find(el => el.value==value));
            }
            else
            {
                setVehicleTempId(vehicles.find(el => el.value==value));
                setChooseModal(true);
            }
        })
    }


    const assignDriverRole = (userData) => {
        post(ASSIGN_ROLE, { UserId: userData.id, RoleId: 3 })
            .then(response => {
            })
            .catch(error => {
                seterrorMsg('Driver Creation Failed');
            })
    }

    const assignExpressDeliveryType = (id) => {
        post(ASSIGN_DELIVERY_TYPE_ACTIVATE, { driverId: id, RoleId: 3, status: expressDeliveryTypeActivate })
            .then(response => {
            })
            .catch(error => {
                console.log(error)
                seterrorMsg('Driver Creation Failed');
            })
    }

    const assignPartnerBranches = (id) => {
        post(UPDATE_DRIVER_PARTNERBRANCHES, { driverId: id, partnerBranches: selectedPartnerBranches })
            .then(response => {
            })
            .catch(error => {
                console.log(error)
                seterrorMsg('Driver Creation Failed');
            })
    }

    const addRange = () => {
        const newOffDays = Object.assign({}, offDays);
        newOffDays.range.push({from:'', to:''});
        setOffDays(newOffDays);
    }

    const setRangeDate = (i, type, value) => {
        const newOffDays = Object.assign({}, offDays);
        if(type == 'from')
            newOffDays.range[i].from = value;
        else if(type == 'to')
            newOffDays.range[i].to = value;
        setOffDays(newOffDays);
    }

    const setDaysOfWeek = (value) => {
        const newOffDays = Object.assign({}, offDays);
        newOffDays.recurring = value;
        console.log('newOffDays.recurring', newOffDays.recurring)
        setOffDays(newOffDays);
    }

    const handleFileUpload = (event) => {
        // setLoading(true);
        const file = event.target.files[0];
        post(`${UPLOAD_FILE}`, { file, type:"partners", fullPath:"true" }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                const data = response.data;
                setPhoto(data.path);
                // setLoading(false);
            })
            .catch((error) => {
            });
    }

    return (
        <React.Fragment>
            <ChooseModal
                show={chooseModal}
                onAllocateClick={handleReallocate}
                onCloseClick={() => setChooseModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Drivers" breadcrumbItem="Add Driver" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Email</Trans></Label>
                                                    <Input
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Enter Email"
                                                        type="email"
                                                        autoComplete="off"
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Mobile</Trans></Label>
                                                    <PhoneInput
                                                        country={'ae'}
                                                        value={mobile}
                                                        className="form-control"
                                                        placeholder="Enter Mobile"
                                                        prefix=""
                                                        searchPlaceholder="Search"
                                                        enableSearch={true}
                                                        autocompleteSearch={true}
                                                        onChange={(e) => setMobile(e)}
                                                        required
                                                    />
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Password</Trans></Label>
                                                    <Input
                                                        name="password"
                                                        className="form-control"
                                                        placeholder="Enter Password"
                                                        type="password"
                                                        autoComplete="false"
                                                        onChange={(e) => setPassword(e.target.value)} 
                                                        required
                                                    ></Input>
                                                </div>

                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Driver Name</Trans></Label>
                                                    <Input
                                                        name="driverName"
                                                        value={driverName}
                                                        className="form-control"
                                                        placeholder="Enter Driver Name"
                                                        type="text"
                                                        onChange={(e) => {setDriverName(e.target.value);setUsername(e.target.value)}}
                                                        required ></Input>
                                                </div>
                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Wallet Balance</Trans></Label>
                                                    <Input
                                                        name="walletBalance"
                                                        value={walletBalance}
                                                        className="form-control"
                                                        placeholder="Enter Wallet Balance"
                                                        type="number"
                                                        onChange={(e) => setWalletBalance(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>License Number</Trans></Label>
                                                    <Input
                                                        name="licenseNo"
                                                        value={licenseNo}
                                                        className="form-control"
                                                        placeholder="Enter  License Number"
                                                        type="text"
                                                        onChange={(e) => setLicenseNo(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>License Expiry</Trans></Label>
                                                    <Input
                                                        name="licenseNo"
                                                        value={licenseExpiry}
                                                        className="form-control"
                                                        placeholder="Enter License Expiry"
                                                        type="date"
                                                        onChange={(e) => setLicenseExpiry(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Car / Vehicle</Trans></Label>
                                                    <Select
                                                            name="vehicleId"
                                                            value={vehicleId}
                                                            options={vehicles} 
                                                            className="form-control select2"
                                                            onChange={(e) => handleVehicleId(e.value)}
                                                        />
                                                </div>

                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Partner Branches</Trans></Label>
                                                    <Select
                                                            name="selectedPartnerBranches"
                                                            value={partnerBranches.filter(branch => {
                                                                return selectedPartnerBranches?.includes(branch.value)
                                                            }
                                                            )}
                                                            options={partnerBranches}
                                                            isMulti 
                                                            className="form-control select2"
                                                            onChange={(e) => handlePartnerBranches(e)}
                                                        />
                                                </div>

                                                <div className="form-group col-md-1 mt-2">
                                                    <Label className="form-label"><Trans>Cargo Employee</Trans></Label>
                                                    <div className="form-check form-check-end">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            value={1}
                                                            id="defaultCheck2"
                                                            defaultChecked={cargoEmployee == 1}
                                                            onClick={(e) => handleToggleCheckBox('setCargoEmployee')}
                                                        />

                                                    </div>
                                                </div>

                                                <div className="form-group col-md-1 mt-2">
                                                    <Label className="form-label"><Trans>Allow Express Change</Trans></Label>
                                                    <div className="form-check form-check-end">
                                                        <FormGroup switch>
                                                        <Input
                                                            type="switch"
                                                            size="md"
                                                            checked={allowExpressChange}
                                                            onClick={() => {
                                                                setAllowExpressChange(allowExpressChange? false : true);
                                                            }}
                                                            />
                                                        </FormGroup>

                                                    </div>
                                                </div>

                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Driver Type</Trans></Label>
                                                    {
                                                        driverTypes.map((type,index) => (

                                                        <div key={index} className="form-check form-check-end">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                value={type.id}
                                                                id="defaultCheck3"
                                                                defaultChecked={false}
                                                                checked={checkDriverType(type.id)}
                                                                onClick={(e) => handleToggleCheckBox('driverType', type.id)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="defaultCheck3"
                                                            >
                                                                <Trans>{type.nameTranslated}</Trans>
                                                            </label>
                                                        </div>
    
                                                        ))

                                                    }
                                                </div>
                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Driver Photo</Trans></Label>
                                                    <input className="form-control" type="file" onChange={handleFileUpload} />
                                                    <img src={photo} className="w-100" />
                                                </div>
                                        </Row>
                                        <Row>
                                            <h3>Off Days</h3>
											<div className=" col-md-6 mt-2">
												<Label>
													<Trans>Recurring Days</Trans>
												</Label>
												<Select
													isMulti
													options={dayOptions}
													value={dayOptions.filter(option =>
														offDays.recurring?.includes(option.value)
													)}
													onChange={selected =>
													setDaysOfWeek(selected.map(item => item.value))
													}
													className="basic-multi-select"
													classNamePrefix="select"
													
												/>
											</div>
											<div className=" col-md-6 mt-2">
                                                <h6>Range</h6>
                                            {offDays?.range?.map((r, i) => 
                                                (
                                                    <div key={i} className="form-group col-md-12 mt-2">
                                                        <Row>
                                                            <div className="form-group col-md-6 mt-2">
                                                                <Label className="form-label"><Trans>From</Trans></Label>
                                                                <Input
                                                                    name="from"
                                                                    value={r.from}
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    type="date"
                                                                    onChange={(e) => setRangeDate(i, 'from', e.target.value)}
                                                                     ></Input>
                                                            </div>
                                                            <div className="form-group col-md-6 mt-2">
                                                                <Label className="form-label"><Trans>To</Trans></Label>
                                                                <Input
                                                                    name="to"
                                                                    value={r.to}
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    type="date"
                                                                    onChange={(e) => setRangeDate(i, 'to', e.target.value)}
                                                                     ></Input>
                                                            </div>
                                                        </Row>
                                                    </div>
                                                )

                                            )}
                                                    <div className="mt-4">
                                                        <Button type="button" color="danger" onClick={addRange}>
                                                            <Trans>Add</Trans>
                                                        </Button>
                                                    </div>
                                            </div>
                                        </Row>
                                        <div className="mt-4">
                                            <Button type="submit" color="primary">
                                                <Trans>Submit</Trans>
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AddDriver
